import { render, staticRenderFns } from "./SalesListEditor.vue?vue&type=template&id=04fcb202&scoped=true"
import script from "./SalesListEditor.vue?vue&type=script&lang=js"
export * from "./SalesListEditor.vue?vue&type=script&lang=js"
import style0 from "./SalesListEditor.vue?vue&type=style&index=0&id=04fcb202&prod&scoped=true&lang=css"
import style1 from "./SalesListEditor.vue?vue&type=style&index=1&id=04fcb202&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fcb202",
  null
  
)

export default component.exports